import React, { createContext, useContext, useState, useEffect } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import UserContext from "../context/UserContext"; // Import the context directly

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const { user } = useContext(UserContext); // Use useContext with UserContext
  const [theme, setTheme] = useState("kids"); // Default theme

  useEffect(() => {
    if (user) {
      const userRef = doc(db, "users", user.uid);
      const unsubscribe = onSnapshot(userRef, (docSnap) => {
        if (docSnap.exists()) {
          const userData = docSnap.data();
          setTheme(userData.age_group.toLowerCase() || "kids");
        }
      }, (error) => {
        console.error("Error syncing theme data:", error);
      });
      return () => unsubscribe();
    }
  }, [user]);

  return (
    <ThemeContext.Provider value={{ theme }}>
      <div className={`${theme}-theme`}>{children}</div>
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);

export default ThemeContext;